import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import logo from "../assets/images/head.png";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 80);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goHome = () => {
    navigate("/");
    setMobileOpen(false);
    setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 250);
  };

  const goGallery = () => {
    navigate("/gallery");
    setMobileOpen(false);
    setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 250);
  };

  const scrollToSection = (id) => {
    navigate("/");
    setMobileOpen(false);
    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }, 300);
  };

  const textColor = isScrolled ? "text-[#4E3421]" : "text-white";
  const hoverColor = isScrolled
    ? "hover:text-[#6D4C30]"
    : "hover:text-[#C8A951]";

  return (
    <motion.nav
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-700 border-b
        ${
          isScrolled
            ? "bg-white/95 border-black/10 shadow-md"
            : "bg-[rgba(0,0,0,0.45)] border-white/10"
        }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">

        {/* Logo */}
        <button onClick={goHome} className="flex items-center gap-3">
          <img src={logo} alt="Ceymos Lanka" className="w-12 h-12" />
          <span className={`text-xl md:text-2xl font-bold tracking-wide ${textColor}`}>
            CEYMOS LANKA
          </span>
        </button>

        {/* Desktop Menu */}
        <div className={`hidden md:flex gap-8 text-base font-medium ${textColor}`}>
          <button onClick={goHome} className={hoverColor}>Home</button>

          <Link to="/tea" onClick={goHome} className={hoverColor}>Tea</Link>
          <Link to="/coconut" onClick={goHome} className={hoverColor}>Coconut</Link>
          <Link to="/spices" onClick={goHome} className={hoverColor}>Spices</Link>
          <Link to="/rice" onClick={goHome} className={hoverColor}>Rice</Link>
          <Link to="/products" onClick={goHome} className={hoverColor}>Products</Link>

          <button onClick={goGallery} className={hoverColor}>Gallery</button>

          <button onClick={() => scrollToSection("about-section")} className={hoverColor}>
            About
          </button>
          <button onClick={() => scrollToSection("contact-section")} className={hoverColor}>
            Contact
          </button>
        </div>

        {/* Mobile Toggle */}
        <button
          className={`md:hidden text-3xl ${textColor}`}
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? "✕" : "☰"}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <motion.div
          initial={{ opacity: 0, y: -15 }}
          animate={{ opacity: 1, y: 0 }}
          className={`md:hidden ${
            isScrolled ? "bg-white/95 text-[#4E3421]" : "bg-black/80 text-white"
          } text-lg py-6 px-6 flex flex-col gap-4`}
        >
          <button onClick={goHome}>Home</button>

          <Link to="/tea" onClick={goHome}>Tea</Link>
          <Link to="/coconut" onClick={goHome}>Coconut</Link>
          <Link to="/spices" onClick={goHome}>Spices</Link>
          <Link to="/rice" onClick={goHome}>Rice</Link>
          <Link to="/products" onClick={goHome}>Products</Link>

          <button onClick={goGallery}>Gallery</button>

          <button onClick={() => scrollToSection("about-section")}>About</button>
          <button onClick={() => scrollToSection("contact-section")}>Contact</button>
        </motion.div>
      )}
    </motion.nav>
  );
};

export default Navbar;
